import React, { useState } from "react";

/** Nextjs */
import dynamic from "next/dynamic";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import {
    MoreVert,
    InfoOutlined,
    FileDownloadOutlined,
    ZoomInOutlined,
    ShareOutlined,
    SaveOutlined,
    CloudDownloadOutlined,
    CloudSyncOutlined,
} from "@mui/icons-material";

/** Redux */
import { useSelector } from "react-redux";
import { getSelectedIndicators } from "../../../../_appStore/DB_Indicators";
import { getShowExperimentalShare, getWithRepository } from "../../../../_appStore/Common";

/** Helpers */
import useHelper from "../../../../_common/useHelper";
import { useTranslation } from "react-i18next";

/** UI */
const AppTooltip = dynamic(() => import("../../../../_common/AppTooltip"));
const Certificate = dynamic(() => import("../../../_Commons/Certificate/Certificate"));
const Share = dynamic(() => import("./Share"));
const Export = dynamic(() => import("./Export"));
// const RepositoryDrawer = dynamic(() => import("../../../RepozytoriumPage/Dialogs/RepositoryDrawer"));

const useStyles = makeStyles((theme) => ({
    MenuRoot: {},
    boxedWrapper: {
        ...theme.shape.boxedWrapper,
        padding: theme.spacing(2, 1, 2, 1),
        minWidth: 215,
    },
}));

const TableActionsMenu = (props) => {
    const { onZoom, request } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const { translationFromJson } = useHelper();

    /** States */
    const [ANCHOR_EL, setANCHOR_EL] = useState(null);
    const [EXPORT, setEXPORT] = useState(false);
    const [OPEN_CERTIFICATE, setOPEN_CERTIFICATE] = useState(false);
    const [SHARE, setSHARE] = useState(false);
    const [REPOSITORY, setREPOSITORY] = useState(false);

    /** Redux selectors */
    const selectedIndicators = useSelector(getSelectedIndicators);
    const showExperimentalShare = useSelector(getShowExperimentalShare);
    const withRepository = useSelector(getWithRepository);

    /** Handlers */
    const handleOpen = (event) => setANCHOR_EL(event.currentTarget);

    const handleClose = () => setANCHOR_EL(null);

    const handleOnCloseCertificate = ({ show }) => {
        setOPEN_CERTIFICATE(show);
        handleClose();
    };

    const handleShare = (show) => {
        process.env.NODE_ENV === "development" && console.log("%c handleShare: ", "background: #666; color:#FFF");
        showExperimentalShare && setSHARE(show);
        handleClose();
    };

    const handleExport = () => {
        setEXPORT(!EXPORT);
        handleClose();
    };

    const handleRepository = () => {
        setREPOSITORY(!REPOSITORY);
        handleClose();
    };

    /** Constants */
    const open = Boolean(ANCHOR_EL);

    const options = [
        {
            name: t("Eksportuj"),
            icon: () => <FileDownloadOutlined fontSize={"small"} />,
            onClick: () => handleExport(),
            disabled: !request,
        },
        // {
        //     name: t("Repozytorium"),
        //     icon: () => <CloudSyncOutlined fontSize={"small"} />,
        //     onClick: () => handleRepository(),
        //     disabled: !withRepository,
        //     hidden: !withRepository,
        // },
    ];
    return (
        <>
            <AppTooltip
                title={t("Otwórz menu z akcjami")}
                arrow
                placement={"top-end"}
                type={"dark"}
                classes={{ tooltip: classes.tooltip }}
            >
                <IconButton
                    role={"menuitem"}
                    aria-label={t("Otwórz menu kontekstowe z akcjami dla tablicy")}
                    id="table-actions-button"
                    // aria-controls={open ? "table-actions-menu" : undefined}
                    // aria-expanded={open ? "true" : undefined}
                    // aria-haspopup="true"
                    onClick={handleOpen}
                >
                    <MoreVert color={"primary"} />
                </IconButton>
            </AppTooltip>
            <Menu
                id="table-actions-menu"
                MenuListProps={{ "aria-labelledby": "table-actions-button" }}
                anchorEl={ANCHOR_EL}
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.boxedWrapper }}
                disablePortal
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "center",
                    horizontal: "right",
                }}
            >
                <MenuItem onClick={() => handleOnCloseCertificate({ show: true })}>
                    <ListItemIcon sx={{ marginRight: 0.5 }}>
                        <InfoOutlined fontSize={"small"} />
                    </ListItemIcon>
                    <ListItemText>{t("Metadane")}</ListItemText>
                </MenuItem>
                {options
                    .filter((option) => !option.hidden)
                    .map((option) => (
                        <MenuItem
                            key={option.name}
                            // onClick={handleClose}
                            sx={{ color: "#000" }}
                            onClick={option.onClick || handleClose}
                            disabled={option.disabled}
                        >
                            <ListItemIcon sx={{ marginRight: 0.5 }}>{option.icon()}</ListItemIcon>
                            <ListItemText>{translationFromJson(option, "name")}</ListItemText>
                        </MenuItem>
                    ))}
            </Menu>
            <Certificate
                indicatorId={selectedIndicators.flatMap((i) => i.indicator_id)}
                item={{}}
                show={OPEN_CERTIFICATE}
                onClose={(show) => handleOnCloseCertificate({ show })}
                color={"primary"}
                hideIcon={true}
            />

            {SHARE ? <Share open={SHARE} setOpen={(show) => handleShare(show)} /> : null}

            {EXPORT ? <Export open={EXPORT} onClose={() => handleExport()} request={request} /> : null}

            {/* <RepositoryDrawer open={REPOSITORY} onClose={() => handleRepository()} source={"db"} /> */}
        </>
    );
};

export default TableActionsMenu;
